export default {"src":"/_next/static/media/right-arrow.f4a1250a.svg","height":16,"width":33,"blurWidth":0,"blurHeight":0};